module.exports = __webpack_public_path__ + "static/media/face2.c5c67506.jpg";